/**
 * API configuration for operator dashboard
 */

// Use environment variable in production, relative path in development (proxy handles it)
export const API_BASE_URL = import.meta.env.VITE_API_URL || '';

/**
 * Fetch wrapper that prepends API base URL
 */
export function apiFetch(path: string, options?: RequestInit): Promise<Response> {
	const url = `${API_BASE_URL}${path}`;
	return fetch(url, options);
}
